<template>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="p-mt-6 p-mb-5 text-title">
      Choisissez le type d'intervention
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-md-10 p-md-offset-1">
        <Card class="main-card">
          <template #content>
            <div class="p-grid">
              <div class="-col-12 p-md-6">
                <Image
                  :src="useImage('schema-pare-brise.png')"
                  alt="Pare-brise"
                />
              </div>
              <div class="-col-12 p-md-6">
                <p>
                  Un impact n'est pas réparable s'il se trouve dans la zone
                  jaune :<br />
                  <strong>à moins de 5cm</strong> du bord du pare-brise, ou bien
                  <strong>dans le champ de vision</strong> du conducteur
                </p>
              </div>
            </div>
          </template>
        </Card>
      </div>

      <div class="p-col-12 p-md-5 p-md-offset-1">
        <Card class="secondary-card" @click="selectTypeOfProblem(1)">
          <template #title>Je choisis un remplacement si :</template>
          <template #content>
            <div class="flexElements">
              <div class="cardText">
                Mon impact se situe
                <span style="background-color: #dfe69f"
                  >dans la zone jaune</span
                >
              </div>
              <div class="cardTextChoice">OU</div>
              <div class="cardText">
                la taille de mon impact est
                <span style="font-weight: bold">supérieure à 2,5 cm</span>
              </div>
            </div>
            <RadioButton
              id="replace"
              name="typeOfProblem"
              value="1"
              v-model="typeOfProblem"
              class="p-my-3 p-my-sm-3"
            />
          </template>
        </Card>
      </div>

      <div class="p-col-12 p-md-5">
        <Card class="secondary-card" @click="selectTypeOfProblem(2)">
          <template #title>Je choisis une réparation si :</template>
          <template #content>
            <div class="flexElements">
              <div class="cardText">
                Mon impact est
                <span style="font-weight: bold"
                  >en dehors de la zone jaune</span
                >
              </div>
              <div class="cardTextChoice">ET</div>
              <div class="cardText">
                la taille est
                <span style="font-weight: bold">inférieure à 2,5 cm</span>
              </div>
            </div>
            <RadioButton
              id="repair"
              name="typeOfProblem"
              value="2"
              v-model="typeOfProblem"
              class="p-my-3 p-my-sm-3"
            />
          </template>
        </Card>
      </div>
    </div>

    <small
      v-if="
        intervention.typeOfProblem.$invalid && intervention.typeOfProblem.$dirty
      "
      class="p-error"
    >
      Veuillez selectionner un type d'intervention
    </small>

    <div class="p-d-inline-flex p-jc-center p-my-6" style="width: 60%">
      <div class="p-mt-sm-3 p-mr-5">
        <Button class="button-navigate button-back" @click="onPrevious">Précédent</Button>
      </div>
      <div class="p-mt-sm-3">
        <Button class="button-navigate" @click="onNext">Suivant</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useMenuStore } from "../stores/menu";
import { useAppointmentStore } from "../stores/appointment";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "StepReplaceOrRepair",

  setup(props, { emit }) {
    const menuStore = useMenuStore();
    const appointmentStore = useAppointmentStore();
    const typeOfProblem = ref(null);

    const rules = {
      typeOfProblem: { required },
    };

    const intervention = useVuelidate(rules, {
      typeOfProblem,
    });

    const getNextUrl = () => {
      let nextUrl = null;
      switch (typeOfProblem.value) {
        case "1":
          nextUrl = "/mon-vehicule";
          appointmentStore.appointment.windshield_reparation = "replace";
          break;
        case "2":
          nextUrl = "/mon-vehicule";
          appointmentStore.appointment.windshield_reparation = "repair";
          break;
      }
      return nextUrl;
    };

    const onNext = () => {
      intervention.value.$touch();
      if (!intervention.value.$error) {
        const nextUrl = getNextUrl();
        const target = menuStore.getMenuItemWithUrl(nextUrl);
        target.parent = menuStore.currentMenuItem.to;

        let dataLayerToPush = {
          'event' : 'click',
          'pageName' : '/prise-de-rendez-vous/#/pare-brise-description',
          'eventCategory' : 'rdv',
          'eventAction' : 'next',
          'eventName' : nextUrl,
        };
        if (appointmentStore.appointment.windshield_reparation) dataLayerToPush.windshield_reparation = appointmentStore.appointment.windshield_reparation;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerToPush);

        emit("nextPage", target);
      }
    };
    const onPrevious = () => {
      appointmentStore.appointment.windshield_reparation = null;
      emit("prevPage", menuStore.currentMenuItem);
    };

    const useImage = (imageName) => {
      return require(`../assets/img/${imageName}`);
    };

    const selectTypeOfProblem = (typeOfProblemId) => {
      typeOfProblem.value = `${typeOfProblemId}`
    }

    return {
      onNext,
      intervention,
      typeOfProblem,
      onPrevious,
      useImage,
      selectTypeOfProblem,
    };
  },
};
</script>

<style>
.interventionSelectorItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.main-card {
  width: 100% !important;
  background-color: #f6f7f8 !important;
  border: 1px dashed #24a285;
}
.main-card .p-card-body {
  padding: 0px !important;
}
.main-card .p-card-content {
  color: black !important;
  font-size: 1.2em !important;
  line-height: 1.5em !important;
  margin: 15px 15px 0px 15px !important;
}
.secondary-card {
  width: 100% !important;
  background-color: #24a285 !important;
  text-align: center !important;
  border: 1px solid #24a285;
  box-shadow: none !important;
  border-radius: 10px !important;
}
.secondary-card .p-card-body {
  padding: 0px !important;
}
.secondary-card .p-card-content {
  background-color: #f6f7f8 !important;
  color: black !important;
  padding: 10px 0px !important;
  font-size: 1.1em !important;
  line-height: 1.6em !important;
  text-align: center;
  border-radius: 0px 0px 10px 10px !important;
}
.secondary-card .p-card-title {
  font-size: 1.5em !important;
  color: white !important;
  padding-top: 10px;
}
.secondary-card .cardTextChoice {
  font-size: 1.5em !important;
  color: #24a285 !important;
  margin: 10px 0px 5px 0px !important;
}
.flexElements {
  display: flex;
  flex-direction: column;
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .secondary-card .p-card-content, .main-card .p-card-content {
    font-size: 0.9em !important;
    line-height: 1.1em !important;
    padding: 8px 3px 0px 3px !important;;
  }
  .secondary-card .p-card-title {
    font-size: 1.1em !important;
  }
}
</style>
